export class MoneyAmount {
    amount: number | string = 0;
    currency = '';

    constructor(amount?: number | string, currency?: string) {
        if (amount)
            this.amount = amount;
        if (currency)
            this.currency = currency;
    }

    setData(data: any) {
        Object.assign(this as any, data);
        return this;
    }

    addAmount(amount: MoneyAmount) {
      this.amount = Number(this.amount) + Number(amount.amount);
      return this;
    }
}
